import { CircularProgress } from "@mui/material";
import React from "react";

export default function PrimaryButton(props) {
  return (
    <button
      type={props.type || "submit"}
      className={` ${props.bgColor || "tw-bg-primary-blue"} ${
        props.textColor || "tw-text-white"
      }  font-w500 btn-block rounded-pill tw-h-[44px] `}
      onClick={props.onClick}
      disabled={props.disabled ?? false}
    >
      {
        props.isLoading ? <CircularProgress color="info" size={30}/>  : <span className="fs-14">{props.text}</span>
      }
      
    </button>
  );
}
